import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import { Spinner } from "../common/Spinner";
import { UserRole } from "../../types/index";

export interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
  redirectTo?: string;
  requireCompleteProfile?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  allowedRoles,
  redirectTo = "/login",
  requireCompleteProfile = true,
}) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size={48} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const currentRole = user.currentRole;
    if (!allowedRoles.includes(currentRole)) {
       return <Navigate to="/" replace />;
    }
  }

  // FIXED: Allow orders page access even if profile incomplete
  if (
    requireCompleteProfile &&
    user.currentRole === "customer" &&
    location.pathname !== "/profile" &&
    location.pathname !== "/orders"
  ) {
    const isProfileIncomplete = !user.name || !user.phone || !user.address;

    if (isProfileIncomplete) {
      return <Navigate to="/profile" state={{ incomplete: true }} replace />;
    }
  }

  return <>{children}</>;
};